// extracted by mini-css-extract-plugin
export default {"scarTable":"inspectionDetailedView_scarTable__w1ATz","detailsContainer":"inspectionDetailedView_detailsContainer__BOLnP"};